/* eslint-disable import/extensions, import/no-unresolved */
import React from 'react';
import { FONT_SIZE } from '@latitude/core/utils/constants';
import { StaticImage } from 'gatsby-plugin-image';

import {
  StyledHeroBranded,
  ImageBox,
  LeaderDetailsWrapper,
  DetailsContainer,
  StyledText,
  LeadershipPageLayout
} from '../../../components/Leadership';

export default props => {
  const title = 'Adriana Martinez';
  const content = 'Executive General Manager, Pay Division';

  return (
    <LeadershipPageLayout title={title} {...props}>
      <StyledHeroBranded
        title={title}
        text={content}
        breadcrumbs={[
          {
            name: 'About us',
            href: '/about-us/'
          },
          {
            name: 'Our company',
            href: '/about-us/our-company/'
          },
          {
            name: 'Adriana Martinez'
          }
        ]}
        imageContent={
          <ImageBox>
            <StaticImage
              alt={title}
              src="../images/adriana-martinez-1.webp"
              width={450}
              quality={100}
              placeholder="dominantColor"
            />
          </ImageBox>
        }
      />
      <LeaderDetailsWrapper>
        <DetailsContainer display="flex">
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Adriana joined Latitude in September 2023 as Executive General
            Manager Pay, where she leads Latitude's Credit Cards and Sales
            Finance Instalment business.
            <br />
            <br />
            Before Latitude, Adriana spent five years at Mastercard in Singapore
            as Senior Vice President, Loyalty, Engagement and Marketing Services
            for Asia Pacific.
            <br />
            <br />
            Adriana has over 25 years of global banking experience, having
            worked in London, Chicago, Singapore and Australia and has held
            senior roles at ANZ and Citibank leading large consumer finance
            businesses. She has broad retail banking and insurance experience
            and began her career at BT Funds management.
          </StyledText>
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Adriana holds a Masters of Management from Macquarie Graduate School
            of Management, a Graduate Diploma in Marketing, a Graduate Diploma
            in Project Management and a Bachelor of Commerce (Economics and
            Finance).
          </StyledText>
        </DetailsContainer>
      </LeaderDetailsWrapper>
    </LeadershipPageLayout>
  );
};
